import { Button, IconArrowUpRight, IconLayout, Text } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { messages } from './messages'
import { styles } from './styles'

type Props = {
  label: string
  variant?: 'info' | 'neutral'
}

export function TemplateInfo(props: Props) {
  const { label, variant = 'neutral' } = props

  const { $t } = useIntl()

  const handleOnClick = () => {
    window.open($t(messages.moreInformationLink), '_blank')
  }

  return (
    <div className={styles.infoTemplateContainer} data-variant={variant}>
      <IconLayout weight="fill" />
      <Text variant="body">{label}</Text>
      <Button
        variant="neutralTertiary"
        iconPosition="end"
        icon={<IconArrowUpRight />}
        onClick={handleOnClick}
      >
        <FormattedMessage {...messages.moreInformation} />
      </Button>
    </div>
  )
}
